// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1A1I1","label":"Completed_label__3I7Be"};